import React from "react";

export default function CopyRight() {
    return (
        <div style={{background: "#f0d8fd",textAlign:"center"}}>
            Copyright &copy; {new Date().getFullYear()} Peter Lau. All Rights Reserved
        </div>);
}